var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.container},[_c('progress',{class:_vm.$style.progress,attrs:{"max":_vm.total},domProps:{"value":_vm.completed}}),(_vm.showCount)?_c('p',{class:_vm.$style.label},[_vm._v(" completed "+_vm._s(_vm.completed)+" of "+_vm._s(_vm.total)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }